import type { FaireProductEntity } from "../../entity_types/product";

export const p_2hmwzcrxpf: FaireProductEntity = {
  token: "p_2hmwzcrxpf",
  type: "product",
  name: "Thank You Card - Bagel Thanks A Lox - Boxed Set of 6",
  brandToken: "b_uu21e90o",
  brandName: "Nicole Marie Paperie",
  imageUrl:
    "https://cdn.faire.com/fastly/4ce426256d5beab2401281ba041428efc6290c10f221912dbfe7ae7e66978f6d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f9734c3953001b23437012166d69a6c156560a4b22fcfd77d6190678f602b90.png",
    "https://cdn.faire.com/fastly/06b9f7ff2b40cc58ec9e865740bd1c4d2096734d0adee058ea7888b6cb659ae2.png",
  ],
  priceDollars: 9,
  description:
    'Thank You Card Boxed Set –Thanks A Lox –Funny foodie theme features a playful bagel and lox pun, for showing gratitude with humor. A cheerful way to say thanks to friends, coworkers, teachers, or loved ones who enjoy a good laugh and foodie flair.\n\nEach card is printed on premium card stock, blank inside for personal notes, and paired with a coordinating envelope.\nBoxed and retail-ready, this set is an ideal addition to gift shops, bookstores, paper goods boutiques, and thank you, humor, or foodie-themed card collections.\n\nIncludes: Set of 6 cards + 6 envelopes\nSize: A2 (4.25" x 5.5")\nEnvelope: Included \nInside: Blank\nDesign: Punny “Thanks A Lox” bagel and lox foodie theme\nPackaging: Clear box, retail-ready\n\nA witty and lighthearted thank you card set, perfect for customers who want to share gratitude with humor in multiples.\n\nMinimum Order Quantity: 3 Sets',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:05.344Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
